import fetchUrl, { fetchJson, postJson } from 'utils/fetch';
import { writeContent } from 'catalog/plugin';

export const fetch = () => fetchJson('/catalog/pages.json');

export const fetchLight = mode =>
  fetchJson(`/catalog/pages/light.json?mode=${mode}`);

export const save = data => postJson('/catalog/pages.json', data);

export const update = (page, contents) => {
  const data = {
    ...page,
    contents: contents
      .map(c => ({
        ...c,
        template: page.template.code,
      }))
      .map(c => writeContent(page.template.code, c)),
  };

  return postJson(`/catalog/pages.json/${page.id}`, data);
};

export const archive = pageId =>
  fetchUrl(`/catalog/pages.json/${pageId}/archive`, {
    method: 'PUT',
  });

export const unarchive = pageId =>
  fetchUrl(`/catalog/pages.json/${pageId}/unarchive`, {
    method: 'PUT',
  });



// WEBPACK FOOTER //
// ./src/modules/catalog/api/pages.js